<template>
    <DashboardSnippet v-slot="{ metrics, operationsLoading, ridersLoading, revenueLoading, assetsLoading, }">
        <div class="p-1">

            <!-- ── Core Stats ───────────────────────────────────────────── -->
            <div class="row g-3 mb-4">
                <div class="col-6 col-md-4">
                    <Counter title="Number of Assets" :value="metrics.engines_count ?? 0" :growth="metrics.total_engines_growth" icon="fa fa-motorcycle" color="text-success" :loading="assetsLoading" />
                </div>
                <div class="col-6 col-md-4">
                    <Counter title="Number of Swaps" :value="metrics.swaps_count ?? 0" :growth="metrics.swap_count_growth" icon="fa fa-recycle" color="text-success" :loading="operationsLoading" />
                </div>
                <!-- <div class="col-6 col-md-3">
                    <Counter title="Active Riders" :value="metrics.active_riders ?? 0" :growth="metrics.active_riders_growth" icon="fa fa-person-biking" color="text-warning" :loading="ridersLoading" />
                </div> -->
                <div class="col-6 col-md-4">
                    <Counter title="Revenue" :value="metrics.total_revenue ?? 0" :growth="metrics.total_revenue_growth" :money-options="{ prefix: '₦', decimalPlaces: 2 }" icon="fa fa-wallet" color="text-info" :loading="revenueLoading" />
                </div>
            </div>

            <!-- ── Revenue Chart ────────────────────────────────────────── -->
            <div class="row g-3 mb-4">
                <div class="col-12 col-md-8">
                    <div class="dash-card chart-card position-relative">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <h6 class="chart-title">Revenue Trends</h6>
                                <p class="chart-subtitle">Daily revenue over selected period</p>
                            </div>
                        </div>
                        <div v-if="revenueLoading" class="card-spinner-overlay">
                            <div class="spinner-border text-success spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <MetricChart :data="metrics.daily_transactions ?? []" chart-type="line" x-key="date" y-key="total_amount" />
                    </div>
                </div>
                <div class="col-12 col-md-4 d-flex">
                    <div class="d-flex flex-column gap-3 w-100">
                        <div class="flex-fill">
                            <Counter title="Credit Repayment" :value="metrics.daily_credit_repayment ?? 0" :growth="metrics.daily_credit_repayment_growth"  :money-options="{ prefix: '₦', decimalPlaces: 2 }" icon="fa fa-coin" color="text-info" :loading="operationsLoading" />
                        </div> 
                        <div class="flex-fill">
                            <Counter title="Transactions" :value="metrics.transaction_count ?? 0" :growth="metrics.transaction_count_growth" icon="fa fa-piggy-bank" color="text-warning" :loading="revenueLoading" />
                        </div>
                        
                    </div>
                </div>
            </div>

            <!-- ── Asset Performance ────────────────────────────────────── -->
            <div class="row g-3 mb-4">
                <div class="col-12">
                    <div class="dash-card position-relative">
                        <div v-if="assetsLoading" class="card-spinner-overlay">
                            <div class="spinner-border text-success spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <!-- <PerformanceTable title="Asset Performance" :performance-data="{
                            top: metrics.top_assets ?? [],
                            least: metrics.least_assets ?? [],
                        }" :enable-date-filter="false" /> -->
                    </div>
                </div>
            </div>

        </div>
    </DashboardSnippet>
</template>

<script lang="ts">
import Counter from '@/vue/components/Counter.vue'
import MetricChart from '@/vue/components/MetricChart.vue'
import PerformanceTable from '@/widget/table/PerformanceTable.vue'
import { Component, Vue, toNative } from 'vue-facing-decorator'
import DashboardSnippet from './DashboardSnippet.vue'

@Component({
    components: { DashboardSnippet, Counter, MetricChart, PerformanceTable },
})
class FinancierDashboard extends Vue { }

export default toNative(FinancierDashboard)
</script>

<style lang="scss" scoped>
.dash-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 1.25rem 1.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
}

.chart-card {
    min-height: 340px;
}

.chart-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
}

.chart-subtitle {
    font-size: 0.78rem;
    color: #9ca3af;
    margin: 0;
}

.card-spinner-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 12px;
    z-index: 10;
}
</style>
